// A custom icon set by the admin wins over the provider's own images.
export function getGameImage(game) {
  return game.custom_icon_url || game.thumbnail_url || game.icon_url;
}
